import { Address, Cell } from "@ton/core";
import { SaleV1 } from "./SaleV1";
import { SaleV2 } from "./SaleV2";
import { SaleV3 } from "./SaleV3";

import { TonClient4 } from "@ton/ton";

enum ContractType {
  SALE_TON,
}

export type ContractsType = SaleV1 | SaleV2 | SaleV3;
export type SaleWrapper = typeof SaleV1 | typeof SaleV2 | typeof SaleV3;

export type CodeVersion = {
  version: string;
  code: Cell;
  wrapper: SaleWrapper;
  contractType: ContractType;
};

export const CODES: CodeVersion[] = [
  {
    version: "1",
    wrapper: SaleV1,
    contractType: ContractType.SALE_TON,
    code: "b5ee9c7241020e01000361000114ff00f4a413f4bcf2c80b0102016203020075a03859da89a1a803a1a601a63ff481f481f480600bf401a9a601a7fe6020f020ce20ac208ab7a1f481f401f481f4006104208c92b0a0158002ab010202cd070402d36a084017d784014a02814942fbcb87089b43e903e803e903e800c0af0803cb8e14ae9cc60192a4114842efcb8e18ae9cc60192a41148c2efcb8e214eca84868542a68462814ac1c20043232c15400f3c5807e80b2dab25c7ec009f08009f5d27080ac248d8db8c354152060500d6708010c8cb055003cf1601fa02cb6ac971fb00702082105fcc3d14c8cb1f13cb3f23cf165003cf16ca008209c9c380fa02ca00c9718018c8cb0528cf1670fa02cb6accc98306fb0071557008c8cb0017cb1f5005cf165003cf1601cf16c9c8cc01fa02cccb00cbffc9ed54002e5067708010c8cb055003cf1601fa02cb6ac971fb00104502f7d00e8698180b8d8492f82707d201876a2686a00e86980698ffd207d207d201802fd006a698069ff98083c0833882b0822b82985e38060004a9885e98f866f10e1804a1805e99fc708c5b31b0b731b2b6416e382c939996f280671166000c92f87f0166002f18111f971c3936ba4e10116c08115dd1660009159d8d840d0804f653dac705b09d1f5f0fd430d0d307d43001fb00e02bc001f2d194b38e4731353b3b5374c705925f0be05173c705f2e1f4821005138d9118baf2e1f5fa403010481037553208c8cb0017cb1f5005cf165003cf1601cf16c9c8cc01fa02cccb00cbffc9ed54e02cc003e3022cc000e3022cc002e30231343b3b08c0060c0b0a0900768e325161c705f2e38a05fa00301048103746531408c8cb0017cb1f5005cf165003cf1601cf16c9c8cc01fa02cccb00cbffc9ed54e05f0a840ff2f0002230393a106b105a1049103847060504f00600245b3839105a1049103847150450637002f00600e630393a3b821005f5e1001abef2e1c95361c7055174c70517b1f2e1ca702082105fcc3d14218010c8cb0526cf1621fa02cb6acb1f17cb3f22cf1622cf1616ca0025fa0215ca00c98306fb00710810374605431308c8cb0017cb1f5005cf165003cf1601cf16c9c8cc01fa02cccb00cbffc9ed54007a313239393939068308d71830ed44f9005116f910f2e38955334330710108c8cb0017cb1f5005cf165003cf1601cf16c9c8cc01fa02cccb00cbffc9ed54dd05067a",
  },
  {
    version: "2",
    wrapper: SaleV2,
    contractType: ContractType.SALE_TON,
    code: "b5ee9c7241020e0100036e000114ff00f4a413f4bcf2c80b010201620302008fa03859da89a1a803a1a601a63ff481f481f480600bf401a9a601a7fe6020f020ce20ac208a05a1f481f401f481f4006104208c92b0a01980020b800220b620b420b220b020aeaa0b0202cd070402d36a084017d784014a02814942fbcb87089b43e903e803e903e800c0af0803cb8e14ae9cc60192a4114842efcb8e18ae9cc60192a41148c2efcb8e214eca84868542a68462814ac1c20043232c15400f3c5807e80b2dab25c7ec009f08009f5d27080ac248d8db8c354152060500d6708010c8cb055003cf1601fa02cb6ac971fb00702082105fcc3d14c8cb1f13cb3f23cf165003cf16ca008209c9c380fa02ca00c9718018c8cb0528cf1670fa02cb6accc98306fb0071557008c8cb0017cb1f5005cf165003cf1601cf16c9c8cc01fa02cccb00cbffc9ed54002e5067708010c8cb055003cf1601fa02cb6ac971fb00104502f7d00e8698180b8d8492f82707d201876a2686a00e86980698ffd207d207d201802fd006a698069ff98083c0833882b0822b82985e38060004a9885e98f866f10e1804a1805e99fc708c5b31b0b731b2b6416e382c939996f280671166000c92f87f0166002f18111f971c3936ba4e10116c08115dd1660009159d8d840d0804f653dac705b09d1f5f0fd430d0d307d43001fb00e02bc001f2d194b38e4731353b3b5374c705925f0be05173c705f2e1f4821005138d9118baf2e1f5fa403010481037553208c8cb0017cb1f5005cf165003cf1601cf16c9c8cc01fa02cccb00cbffc9ed54e02cc003e3022cc000e3022cc002e30231343b3b08c0060c0b0a0900768e325161c705f2e38a05fa00301048103746531408c8cb0017cb1f5005cf165003cf1601cf16c9c8cc01fa02cccb00cbffc9ed54e05f0a840ff2f0002230393a106b105a1049103847060504f00600245b3839105a1049103847150450637002f00600e630393a3b821005f5e1001abef2e1c95361c7055174c70517b1f2e1ca702082105fcc3d14218010c8cb0526cf1621fa02cb6acb1f17cb3f22cf1622cf1616ca0025fa0215ca00c98306fb00710810374605431308c8cb0017cb1f5005cf165003cf1601cf16c9c8cc01fa02cccb00cbffc9ed54007a313239393939068308d71830ed44f9005116f910f2e38955334330710108c8cb0017cb1f5005cf165003cf1601cf16c9c8cc01fa02cccb00cbffc9ed547d5a3020",
  },
  {
    version: "3",
    wrapper: SaleV3,
    contractType: ContractType.SALE_TON,
    code: "b5ee9c7241020e01000372000114ff00f4a413f4bcf2c80b010201620302008fa03859da89a1a803a1a601a63ff481f481f480600bf401a9a601a7fe6020f020ce20ac208a05a1f481f401f481f4006104208c92b0a01980020b800220b620b420b220b020aeaa0b0202cd070402d36a084017d784014a02814942fbcb87089b43e903e803e903e800c0af0803cb8e14ae9cc60192a4114842efcb8e18ae9cc60192a41148c2efcb8e214eca84868542a68462814ac1c20043232c15400f3c5807e80b2dab25c7ec009f08009f5d27080ac248d8db8c354152060500d6708010c8cb055003cf1601fa02cb6ac971fb00702082105fcc3d14c8cb1f13cb3f23cf165003cf16ca008209c9c380fa02ca00c9718018c8cb0528cf1670fa02cb6accc98306fb0071557008c8cb0017cb1f5005cf165003cf1601cf16c9c8cc01fa02cccb00cbffc9ed54002e5067708010c8cb055003cf1601fa02cb6ac971fb00104502f7d00e8698180b8d8492f82707d201876a2686a00e86980698ffd207d207d201802fd006a698069ff98083c0833882b0822b82985e38060004a9885e98f866f10e1804a1805e99fc708c5b31b0b731b2b6416e382c939996f280671166000c92f87f0166002f18111f971c3936ba4e10116c08115dd1660009159d8d840d0804f853dac705b09d1f5f0fd430d0d307d43001fb00e02bc001f2d194b38e4731353b3b5374c705925f0be05173c705f2e1f4821005138d9118baf2e1f5fa403010481037553208c8cb0017cb1f5005cf165003cf1601cf16c9c8cc01fa02cccb00cbffc9ed54e02cc003e3022cc000e3022cc002e3023133333a3a07c0060c0b0a09007c8e355155c705f2e38a07fa00d43010481037102610455a08c8cb0017cb1f5005cf165003cf1601cf16c9c8cc01fa02cccb00cbffc9ed54e05f09840ff2f0002230393a106b105a1049103847060504f00600245b3839105a1049103847150450637002f00600e630393a3b821005f5e1001abef2e1c95361c7055174c70517b1f2e1ca702082105fcc3d14218010c8cb0526cf1621fa02cb6acb1f17cb3f22cf1622cf1616ca0025fa0215ca00c98306fb00710810374605431308c8cb0017cb1f5005cf165003cf1601cf16c9c8cc01fa02cccb00cbffc9ed54007a313239393939068308d71830ed44f9005116f910f2e38955334330710108c8cb0017cb1f5005cf165003cf1601cf16c9c8cc01fa02cccb00cbffc9ed54397872cf",
  },
].map((item) => ({
  ...item,
  code: Cell.fromBoc(Buffer.from(item.code, "hex"))[0],
}));

export const saleTonMasters = CODES.filter(
  (item) => item.contractType === ContractType.SALE_TON
);

export const saleCode: Cell = CODES[CODES.length - 1].code;

export const saleWrapper: SaleWrapper = CODES[CODES.length - 1].wrapper;

// @RepeatAsyncDecorator()
export async function getClient(): Promise<TonClient4> {
  // const endpoint = await getHttpV4Endpoint({
  //   network: this.configService.get<any>('TON_NETWORK'),
  // });

  return new TonClient4({
    endpoint: "https://mainnet-v4.tonhubapi.com",
    // apiKey: this.configService.get<any>('TON_CENTER_KEY'),
  });
}

export async function checkSaleCode(
  address: string
): Promise<CodeVersion | undefined> {
  const client = await getClient();
  const { last } = await client.getLastBlock();
  const data: {
    account: {
      balance: {
        coins: string;
      };
      state:
        | {
            type: "uninit";
          }
        | {
            data: string | null;
            code: string | null;
            type: "active";
          }
        | {
            type: "frozen";
            stateHash: string;
          };
      last: {
        lt: string;
        hash: string;
      } | null;
      storageStat: {
        lastPaid: number;
        duePayment: string | null;
        used: {
          bits: number;
          cells: number;
          publicCells: number;
        };
      } | null;
    };
    block: {
      workchain: number;
      shard: string;
      seqno: number;
      fileHash: string;
      rootHash: string;
    };
  } = await client.getAccount(last.seqno, Address.parse(address));

  if (
    data.account.state.type !== "active" ||
    data.account.state.code === null
  ) {
    return undefined;
  }

  const [targetCell] = Cell.fromBoc(
    Buffer.from(data.account.state.code, "base64")
  );

  for (const item of CODES) {
    if (item.code.hash().equals(targetCell.hash())) {
      return item;
    }
  }
}
